export default __webpack_public_path__ + "static/media/cargo_truck.92bc5462.svg";